export default __webpack_public_path__ + "static/media/292.46c0a338.png";